import { Pipe, PipeTransform } from '@angular/core';
import { ListIteratee, Many, orderBy } from 'lodash';

@Pipe({
  name: 'orderBy',
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform<T>(
    array: T[],
    iteratees?: Many<ListIteratee<T>> | undefined,
    orders?: Many<boolean | 'asc' | 'desc'> | undefined
  ): T[] {
    return orderBy<T>(array, iteratees, orders);
  }
}
